// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"211bcdf4","338":"3bbb1c44","551":"1eb6409a","645":"0cb8de06","842":"74fd6e85"}[chunkId] + ".chunk.js";
};